































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { getWebsiteDocument } from '@src/api/website-document';
import { openNewTab } from '@src/utils/client';

@Component
export default class FooterDisclaimer extends Vue {
	@Prop({ default: false })
	footerFull!: boolean;

	appBasePath = process.env.VUE_APP_BASE_PATH;
	privacyPolicyDoc = 'Privacy Policy';
	termsOfServiceDoc = 'Terms of Service';

	get currentYear(): number {
		const today = new Date();
		return today.getFullYear();
	}

	public async openDocument(docName: string): Promise<void> {
		try {
			const documentLink = await getWebsiteDocument(docName);
			openNewTab(documentLink.redirectUrl);
		} catch {}
	}
}
